export default "/_next/static/src/lib/assets/rive/e751ca5291acdb8d76fd1e604754cf76.riv";